import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { TID } from "@/lib/testIds";

// Default fallback content (used when admin hasn't customised the page yet).
const DEFAULT_ABOUT_TITLE = "Quiénes somos";
const DEFAULT_ABOUT_CONTENT = `Sur Primicia es un portal digital de noticias con foco en Río Grande, Tierra del Fuego, Antártida e Islas del Atlántico Sur. Nacimos con la vocación de contar la provincia desde adentro, con un lenguaje claro, con fuentes chequeadas y con una mirada federal.

Cada día publicamos información sobre política, economía, sociedad, cultura, deportes y servicios de las tres ciudades fueguinas. Cubrimos también la agenda nacional e internacional que impacta al sur.

Trabajamos con criterios propios, sin condicionamientos externos: nuestra brújula es el interés público fueguino. Contrastamos cada dato con fuentes múltiples y, cuando corresponde, publicamos rectificaciones con la misma jerarquía.

¿Querés escribirnos, sumar tu voz o colaborar? Podés hacerlo a través de nuestra página de contacto.`;

export default function AboutPage() {
  const [content, setContent] = useState({
    title: DEFAULT_ABOUT_TITLE,
    body: DEFAULT_ABOUT_CONTENT,
  });

  useEffect(() => {
    api.siteSettings()
      .then((s) => {
        setContent({
          title: (s?.about_title && s.about_title.trim()) || DEFAULT_ABOUT_TITLE,
          body: (s?.about_content && s.about_content.trim()) || DEFAULT_ABOUT_CONTENT,
        });
      })
      .catch(() => { /* keep defaults */ });
  }, []);

  const paragraphs = content.body.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);

  return (
    <div data-testid={TID.aboutPage} className="container-wide py-10">
      <div className="text-xs uppercase tracking-[0.18em] text-turquoise font-semibold mb-2">Institucional</div>
      <h1 className="font-serif font-black text-4xl sm:text-5xl text-blueblack">{content.title}</h1>
      <div className="mt-6 h-[3px] w-16 bg-watergreen" />

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-6 text-blueblack leading-[1.85] text-[17px]" data-testid="about-body">
          {paragraphs.map((p, i) => (
            <p key={i} className="whitespace-pre-line">{p}</p>
          ))}
          <p className="text-sm text-textgray pt-2">
            Podés escribirnos desde nuestra{" "}
            <Link to="/contacto" className="text-petroleum hover:text-turquoise underline underline-offset-4">
              página de contacto
            </Link>
            .
          </p>
        </div>

        <aside className="bg-white border border-softblue p-6 sm:p-8">
          <div className="text-xs uppercase tracking-[0.18em] text-turquoise font-semibold">Ficha rápida</div>
          <dl className="mt-4 space-y-4 text-sm">
            <div>
              <dt className="text-textgray uppercase tracking-widest text-[11px]">Cobertura</dt>
              <dd className="mt-1 font-semibold text-nightblue">Río Grande · Ushuaia · Tolhuin · Provincia · Nación</dd>
            </div>
            <div>
              <dt className="text-textgray uppercase tracking-widest text-[11px]">Frecuencia</dt>
              <dd className="mt-1 font-semibold text-nightblue">Actualización continua, 365 días</dd>
            </div>
            <div>
              <dt className="text-textgray uppercase tracking-widest text-[11px]">Zona horaria</dt>
              <dd className="mt-1 font-semibold text-nightblue">America/Argentina/Ushuaia (UTC−3)</dd>
            </div>
            <div>
              <dt className="text-textgray uppercase tracking-widest text-[11px]">Idioma</dt>
              <dd className="mt-1 font-semibold text-nightblue">Español (Argentina)</dd>
            </div>
          </dl>
        </aside>
      </div>
    </div>
  );
}
